import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { EnvironmentLoaderService } from './core/services/environment-loader.service';
import { environment } from 'src/environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { NavigationExtras, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import jwt_decode from 'jwt-decode';
import { SharedService } from './core/services/shared.service';
import { NewFooterComponent } from './shared/components/new-footer/new-footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, NewFooterComponent],
  // TODO: This component has been partially migrated to be zoneless-compatible.
  // After testing, this should be updated to ChangeDetectionStrategy.OnPush.
})
export class AppComponent implements OnInit {
  private service = inject(TelemetryService);
  private envLoaderSerive = inject(EnvironmentLoaderService);
  private http = inject(HttpClient);
  private router = inject(Router);
  private keycloakservice = inject(KeycloakService);
  private sharedService = inject(SharedService);
  
  title = 'partnerhub-ui';
  telemetryendurl: string = environment.TELEMETRY_SERVICE_ENDPOINT;
  BATCH_SIZE = 1;
  public telemetryConfig = {
    pdata: {
      id: 'angular.partnerHub',
      ver: '1.0.0',
      pid: '',
    },
    uid: '',
    authtoken: '',
    env: 'value',
    channel: 'web',
    batchsize: this.BATCH_SIZE,
    host: '',
    endpoint: this.telemetryendurl,
    apislug: '',
    // 'sid':this.guid
  };
  maintenanceMode: boolean;
  token1: string;
  name: string;
  unAuthFlag = true;

  ngOnInit(): void {
    console.log('ift deployment+token expire+maintenance+paginationfixed + APP D fixes+10august2026_v1.0');
    this.keycloakservice.getToken().then((res: string) => {
      try {
        this.token1 = res;
        if (this.token1) {
          localStorage.setItem('access_token', this.token1);
          const decoded = jwt_decode(this.token1) as any;
          localStorage.setItem('vendorCode', decoded.vendorCode);
          localStorage.setItem('email', decoded.email);
          localStorage.setItem('loggedInUser', decoded.firstName);
          const scheduleRefresh = (exp: number) => {
            const refreshIn = exp * 1000 - Date.now() - 60000;
            setTimeout(() => {
              this.keycloakservice.updateToken(60).then((refreshed) => {
                if (refreshed) {
                  console.log('Token refreshed');
                  this.keycloakservice.getToken().then((newToken: string) => {
                    localStorage.setItem('access_token', newToken);
                    const newDecoded = jwt_decode(newToken) as any;
                    localStorage.setItem('vendorCode', newDecoded.vendorCode);
                    localStorage.setItem('email', newDecoded.email);
                    localStorage.setItem('loggedInUser', newDecoded.firstName);
                    console.debug('Token refreshed');
                    scheduleRefresh(newDecoded.exp);
                  });
                } else{
                  this.keycloakservice.login();
                }
              }).catch(() => {
                this.keycloakservice.login();
              });
            }, Math.max(0, refreshIn)); 
          };
          scheduleRefresh(decoded.exp);
        }
      } catch (_error) {
        console.warn('User not authenticated');
      }
    });
    this.service.provider = 'SUNBIRD';
    this.envLoaderSerive.getEnvData().then((envjson) => {
      environment.TELEMETRY_SERVICE_HOST = envjson['TELEMETRY_SERVICE_HOST'];
      environment.TELEMETRY_SERVICE_ENDPOINT = envjson['TELEMETRY_SERVICE_ENDPOINT'];
      environment.timeSheetURL = envjson['TimeSheetServiceUrl'];
      environment.partnerHubServices = envjson['PartnerHubServices'];
      environment.timeSheetServiceUrl = envjson['TimeSheetServiceUrl'];
      environment.partnerHubFrameWorkServices = envjson['PartnerHubFrameWorkServices'];
      this.telemetryConfig['host'] = envjson['TELEMETRY_SERVICE_HOST'];
      this.telemetryConfig['authtoken'] = localStorage.getItem('access_token');
      this.telemetryConfig['uid'] = localStorage.getItem('email');
      this.service.setProviderImplementation('SUNBIRD', this.telemetryConfig);
      this.service.start(this.telemetryConfig, 'contentId1', '1.0', {});
      this.service.log({
        type: 'Info',
        itype: 'logging',
        pageid: 'AppComponent',
        detail:
          localStorage.getItem('email') +
          ' has logged in successfully having vendor code ' +
          localStorage.getItem('vendorCode'),
      });
      this.loadApp();
    });
  }

  loadApp() {
    if (!window.location.pathname.includes('/forgot-password')) {
      this.getUserEmail()
        .then((userEmail) => {
          if (typeof userEmail === 'string') {
            const emailDomain = userEmail.split('@')[1];
            if (
              emailDomain &&
              (emailDomain.toLowerCase() === 'ad.infosys.com' || emailDomain.toLowerCase() === 'infosys.com')
            ) {
              this.checkUserAccess()
                .then((user: any) => {
                  if (!user.subconFlag) {
                    this.unAuthFlag = true;
                    const navigationExtras: NavigationExtras = {
                      queryParams: {
                        flag: this.unAuthFlag,
                      },
                    };
                    this.sharedService.accessCheck(this.unAuthFlag);
                    this.router.navigate(['/unauth'], navigationExtras);
                  } else {
                    this.unAuthFlag = false;
                    const navigationExtras: NavigationExtras = {
                      queryParams: {
                        flag: this.unAuthFlag,
                      },
                    };
                    this.sharedService.accessCheck(this.unAuthFlag);
                    this.router.navigate(['/app-wall'], navigationExtras);
                  }
                })
                .catch((error) => {
                  console.error('Error checking user access:', error);
                });
            } else {
              this.unAuthFlag = false;
              const navigationExtras: NavigationExtras = {
                queryParams: {
                  flag: this.unAuthFlag,
                },
              };
              this.sharedService.accessCheck(this.unAuthFlag);
              this.router.navigate(['/app-wall'], navigationExtras);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  checkUserAccess() {
    return new Promise((resolve, _reject) => {
      // let timeSheetURL = environment.timeSheetServiceUrl;
      this.sharedService.getTimesheetAuth().subscribe(
        (data) => {
          resolve(data);
        },
        (_error) => {
          const info = {
            msg: 'Technical _error occured, please try again later',
            isSuccess: false,
          };
          this.sharedService.openSnackBar(info, 'success-snack');
          this.unAuthFlag = true;
          const navigationExtras: NavigationExtras = {
            queryParams: {
              flag: this.unAuthFlag,
            },
          };
          this.sharedService.accessCheck(this.unAuthFlag);
          this.router.navigate(['/unauth'], navigationExtras);
        },
      );
    });
  }

  getUserEmail() {
    return new Promise((resolve, _reject) => {
      const userEmail = localStorage.getItem('email');
      if (userEmail) {
        resolve(userEmail);
      } else {
        this.sharedService.getUserDetails().subscribe((data) => {
          resolve(data.email);
        });
      }
    });
  }
}
